import { useMemo } from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import { compact, uniq } from 'lodash'
import { selectCustomers } from 'gdl/customers/CustomersSlice'

// Types de note déjà utilisés (tous clients confondus), pour l'autocomplete freesolo du type.
// Source unique partagée par la liste des clients, le dashboard client et le menu Notes.
const useNoteTypeOptions = () => {
    const customers = useSelector(selectCustomers, shallowEqual)
    return useMemo(
        () => uniq(compact((customers ?? []).flatMap(c => (c.notes ?? []).map(n => n.typeNote)))),
        [customers],
    )
}

export default useNoteTypeOptions
